import { createSlice } from '@reduxjs/toolkit';
import { actions as itemActions } from 'state/items/slice';
import { stateName } from './constants';
const initialState = {
  isSoldNotificationShown: false
};

const setIsSoldNotificationShown = (draft, action) => {
  const {
    sold
  } = action.payload;
  draft.isSoldNotificationShown = !!sold;
};

const hideSoldNotification = draft => {
  draft.isSoldNotificationShown = false;
};

const favouriteSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    hideSoldNotification
  },
  extraReducers: {
    [itemActions.getFavouriteItemsSuccess.type]: setIsSoldNotificationShown
  }
});
export const {
  actions
} = favouriteSlice;
export const plug = {
  [stateName]: favouriteSlice.reducer
};
export default favouriteSlice.reducer;